import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'

const absolute = (path?: string): string | undefined => {
    if (!path) return undefined
    if (path.startsWith('http')) return path

    return `${siteConfig.url}${path.startsWith('/') ? path : `/${path}`}`
}

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage
}): ReactNode => {
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const image = absolute(ogImage)

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:url' content={siteConfig.url} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {image && (
                <>
                    <meta property='og:image' content={image} />
                    <meta name='twitter:image' content={image} />
                </>
            )}
        </Head>
    )
}
